module.exports = __webpack_public_path__ + "img/research-group-1.e8822150.jpg";